import React from "react";
import {IIconGeneralPropsColor} from "modules/types";

export const IconError: React.FC<IIconGeneralPropsColor> = ({
	width = 24,
	height = 24,
	color = "#EBCA5E",
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 120 120"
			fill="none">
			<path
				d="M60 10C32.4 10 10 32.4 10 60C10 87.6 32.4 110 60 110C87.6 110 110 87.6 110 60C110 32.4 87.6 10 60 10ZM65 85H55V75H65V85ZM65 65H55V35H65V65Z"
				fill={color}
			/>
		</svg>
	);
};
